module.exports = __webpack_public_path__ + "static/media/ministry_upload_template.7ab4f7e5.csv";